import Header from "./components/Header";
import Intro from "./components/Intro";
import AboutMe from "./components/AboutMe";
import AboutTherapy from "./components/AboutTherapy";
import Benefits from "./components/Benefits";
import Cases from "./components/Cases";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <Intro />
      <AboutMe />
      <AboutTherapy />
      <Benefits />
      <Cases />
      <Footer />
    </>
  );
}

export default App;
